import BaseService from "../../BaseService";

export default class ZVVService extends BaseService {

  constructor(prefix, id) {
    if (prefix) {
      super(`${prefix}/${id}/zvv`);
    } else {
      super(`zvv/${id}`);
    }
  }

}
